var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInscrever(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-inscrever",
    transform: "translate(-140 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-transp",
    width: 40,
    height: 40,
    transform: "translate(140 639)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    d: "M385.462,261.256l-2.989-2.989a2.84,2.84,0,0,1-4-4l-2.992-2.992a1.768,1.768,0,0,0-2.493,0l-3.526,3.529a.908.908,0,0,1,.217.146.882.882,0,1,1-1.249,1.245.927.927,0,0,1-.146-.217l-14.007,14.01a1.769,1.769,0,0,0,0,2.493l2.992,2.991a2.839,2.839,0,0,1,4,4l2.989,2.988a1.77,1.77,0,0,0,2.5,0l14.007-14.01a.765.765,0,0,1-.215-.143.881.881,0,0,1,1.245-1.245.858.858,0,0,1,.146.215l3.527-3.526A1.773,1.773,0,0,0,385.462,261.256Zm-13.766-3.04a.882.882,0,1,1,0-1.248A.884.884,0,0,1,371.7,258.216Zm2.02,2.02a.882.882,0,1,1,0-1.248A.887.887,0,0,1,373.716,260.236Zm2.017,2.017a.882.882,0,1,1,0-1.248A.88.88,0,0,1,375.733,262.253Zm2.02,2.02a.882.882,0,1,1,0-1.247A.885.885,0,0,1,377.752,264.272Zm2.018,2.018a.882.882,0,1,1,0-1.248A.88.88,0,0,1,379.77,266.29Z",
    transform: "translate(-209.871 392.13)",
    fill: "#287092"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInscrever);
export default __webpack_public_path__ + "static/media/icon-inscrever.8d635791b94ac4230ec9981d6071b0eb.svg";
export { ForwardRef as ReactComponent };